var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "h2",
        {
          staticClass:
            "text-2.5xl font-sans-bold text-n-gray-dark font-hairline mb-6",
        },
        [_vm._v("\n    Our Story\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pl-5" }, [
        !_vm.hasCompleted
          ? _c(
              "h3",
              { staticClass: "text-n-gray-dark text-2xl font-hairline" },
              [
                _vm._v(
                  "\n      Share your story with your audience to help them get to know you and how you can help address needs they care about.\n    "
                ),
              ]
            )
          : _c("div", {
              staticClass:
                "text-n-gray-dark text-lg leading-org_edit_content font-hairline",
              domProps: { innerHTML: _vm._s(_vm.content) },
            }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-6" },
        [
          _c(
            "EventEditBtn",
            {
              attrs: { completed: _vm.hasCompleted },
              on: {
                click: function ($event) {
                  _vm.modalOpen = true
                },
              },
            },
            [_vm._v("\n      Add your story\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("OrganizationStoryModal", {
        model: {
          value: _vm.modalOpen,
          callback: function ($$v) {
            _vm.modalOpen = $$v
          },
          expression: "modalOpen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }